import React, { useEffect } from "react";
import "./App.css";
import { VirtualPath } from "./VirtualPath";
import { AuthProvider } from "./context/AuthContext";

const App = () => {
  const isEmergencyMaintenance =
    String(process.env.REACT_APP_EMERGENCY_MAINTENANCE).toLowerCase() ===
    "true";

  useEffect(() => {
    const pathToTitleMap = {
      "/hrms/org": "Organization Charts",
      "/hrms/org/": "Organization Charts",
      "/hrms/org/unit": "Org Chart Admin",
      "/hrms/org/unit/": "Org Chart Admin" };

    const pathname = window.location.pathname;
    const isProbationPath =
      pathname === "/hrms/probation" ||
      pathname === "/hrms/probation/" ||
      pathname.startsWith("/hrms/probation/");
    const documentTitle = isProbationPath
      ? "Probation Assessment"
      : pathToTitleMap[pathname] || "E-leave"; // Default title if no match
    if (isEmergencyMaintenance) {
      document.title = "Emergency Maintenance";
      return;
    }
    document.title = documentTitle;
  }, [isEmergencyMaintenance]);

  if (isEmergencyMaintenance) {
    return (
      <div
        id="container"
        className="container"
        style={{
          width: "100%",
          minHeight: "100vh",
          margin: 0,
          backgroundColor: "#f4f6f5",
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "center",
          padding: "80px 24px 24px",
          boxSizing: "border-box" }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: "760px",
            backgroundColor: "#ffffff",
            border: "1px solid #d9dfdc",
            borderRadius: "10px",
            boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
            padding: "40px 32px",
            textAlign: "center",
            fontFamily: "Arial, sans-serif",
            color: "#4d5752",
            lineHeight: "1.7" }}
        >
          <h1
            style={{
              margin: "0 0 16px",
              color: "#2f6f4f",
              fontSize: "2rem",
              fontWeight: 700 }}
          >
            Server Under Emergency Maintenance
          </h1>
          <p style={{ margin: "0 0 8px", fontSize: "1.05rem" }}>
            We are currently performing emergency maintenance to resolve a
            critical issue.
          </p>
          <p style={{ margin: "0 0 8px", fontSize: "1.05rem" }}>
            Our team is working hard to restore normal service as quickly as
            possible.
          </p>
          <p style={{ margin: "0 0 8px", color: "#6a7570" }}>
            Please check back shortly.
          </p>
          <p style={{ margin: 0, color: "#6a7570" }}>
            Thank you for your patience and understanding.
          </p>
          <p
            style={{
              margin: "14px 0 0",
              color: "#6a7570",
              fontSize: "0.98rem" }}
          >
            For urgent issues, please contact Nattanan Seeruang or submit a
            support ticket.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div id="container" className="container" style={{ width: "99%" }}>
      <AuthProvider>
        <VirtualPath />
      </AuthProvider>
    </div>
  );
};

export default App;




